import React from "react";

const DisplayError = props => {
    return(
        <div className="error-message">
            {props.error}
        </div>
    )
}

export default DisplayError;